// extracted by mini-css-extract-plugin
export default {"HeaderTitle":"Header_HeaderTitle__tyq9j","HeaderTitleAdmin":"Header_HeaderTitleAdmin__iTmM8"};